import * as z from 'zod';
import { zEmail } from './error-messages';

export const addEmailFormSchema = z.object({
  email: zEmail,
});

export type AddEmailFormData = z.TypeOf<typeof addEmailFormSchema>;
